import { Suspense } from "react";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { routes } from "../constants";
import store from "../store/store";
import { getIdAuthority, getMode, isBlast } from "../utils";
import { lazyWithReload } from "../utils/lazyWithReload";
import {
	CustomQueryClientProvider,
	ErrorBoundary,
	Preloader,
	oidcConfig,
} from ".";
import { debugUtils } from "../api/api";

// Route chunks are loaded via lazyWithReload so a stale tab recovers from a
// missing chunk after a redeploy (see utils/lazyWithReload).
const RouterSwitch = lazyWithReload(() => import("../routerSwitch"), "routerSwitch");
const RouterSwitchBlast = lazyWithReload(
	() => import("../routerSwitchBlast"),
	"routerSwitchBlast",
);

export const TheNeedsBe = ({ children }: { children: any }) => (
	<AuthProvider {...oidcConfig}>
		<Provider store={store}>
			<CustomQueryClientProvider>
				<BrowserRouter>
					<ErrorBoundary>{children}</ErrorBoundary>
				</BrowserRouter>
			</CustomQueryClientProvider>
		</Provider>
	</AuthProvider>
);

export const App = () => {
	const queryParams = new URLSearchParams(window.location.search);
	const userId = queryParams.get("getStarted");
	if (import.meta.env.DEV) {
		// @ts-ignore
		window.debugAuth = debugUtils;
	}

	if (userId) {
		const newUrl =
			getIdAuthority() +
			routes.login.path +
			"?userId=" +
			userId +
			"&returnUrl=" +
			encodeURI(window.location.href.split("?")[0]);

		window.location.replace(newUrl);

		return <Preloader />;
	}
	console.log(getMode());

	if (isBlast)
		return (
			<TheNeedsBe>
				<Suspense fallback={<Preloader />}>
					<RouterSwitchBlast />
				</Suspense>
				<ToastContainer />
			</TheNeedsBe>
		);

	return (
		<TheNeedsBe>
			<Suspense fallback={<Preloader />}>
				<RouterSwitch />
			</Suspense>
			<ToastContainer />
		</TheNeedsBe>
	);
};
